(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Earbuds-Product-Grid"] && !Shopify.designMode) return;
  try {
    
async function handleAddToCart(e, button) {
  e.preventDefault();
  const form = button.closest('form');
  const spinner = button.querySelector('.spinner');
  const btnText = button.querySelector('.btn-text');

  button.disabled = true;
  spinner.classList.remove('hidden');
  btnText.classList.add('opacity-0');

  try {
    const formData = new FormData(form);
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    // Toast
    const msg = document.createElement('div');
    msg.textContent = 'Added to cart ✅';
    msg.className =
      'fixed bottom-5 left-1/2 -translate-x-1/2 bg-green-600 text-white px-4 py-2 rounded-md shadow-md z-50 animate-fade';
    document.body.appendChild(msg);
    setTimeout(() => msg.remove(), 1500);
  } catch (err) {
    console.error('Add to cart error:', err);
  } finally {
    button.disabled = false;
    spinner.classList.add('hidden');
    btnText.classList.remove('opacity-0');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
